import React, { Component } from 'react'
import { v4 as uuidv4 } from 'uuid';
import styles from "./ExtendBlock.module.css"

const SELECT_INDICATE_STYLE = "6px double rgba(221,30,11,0.4)"
export default class ExtendBlock extends Component {
    constructor(props) {
        super(props)

        this.state = {
            select: false,
            extendCompVisible: false,
            extendStyleVisible: true
        }
        this.timeInst = null
    }
    // sub-compponent
    ExtCompList = () => {
        // inner function of extend component
        const extendComp = (id, className, evtHandler) => {
            return (<div key={id} className={className} onClick={(e) => { evtHandler(e); e.stopPropagation(); }}>+</div>)
        }

        const leftComp = extendComp(0, styles.leftExtStyle, (e) => { this.props.dirClickHandler(e, "LEFT") })
        const topComp = extendComp(1, styles.topExtStyle, (e) => { this.props.dirClickHandler(e, "TOP") })
        const bottomComp = extendComp(2, styles.bottomExtStyle, (e) => { this.props.dirClickHandler(e, "BOTTOM") })
        const rightComp = extendComp(3, styles.rightExtStyle, (e) => { this.props.dirClickHandler(e, "RIGHT") })

        const removeComp = <div key={4} className={styles.removeExtStyle} onClick={(e) => { this.props.removeHandler(e) }}>X</div>
        return (
            [leftComp, topComp, bottomComp, rightComp, removeComp]
        )
    }
    // Handler
    selectHandler = (e) => {
        this.props.selectHandler(e, this.ref)
    }
    updateStyle = () => {
        var style = { outline: "", borderLeft: "", borderTop: "" }
        if (this.state.extendStyleVisible) {
            style.outline = (this.props.childState && this.props.childState.select) ? SELECT_INDICATE_STYLE : ""
        }

        return style
    }

    enableExtCompHandler = (e) => {
        if (this.timeInst)
            clearTimeout(this.timeInst)
        this.setState(state => { return { extendStyleVisible: true } })
        this.setState(state => { return { extendCompVisible: true } })
        if (this.props.childState.select)
            document.getElementsByTagName("body")[0].classList.add(styles.stopScrolling)
    }
    disableExtCompHandler = (e) => {
        if (this.timeInst)
            clearTimeout(this.timeInst)
        this.timeInst = setTimeout(() => {
            this.setState(state => { return { extendStyleVisible: false } })
        }, 1000)

        this.setState(state => { return { extendCompVisible: false } })
        if (this.props.childState.select)
            document.getElementsByTagName("body")[0].classList.remove(styles.stopScrolling)
    }
    // mount ref container
    mountRefHandler = (ref) => { this.ref = ref }
    componentDidUpdate() {
        if (this.props.childState) {
            this.setState(state => {
                if (state.select != this.props.childState.select) {
                    if (this.props.childState.select)
                        document.getElementsByTagName("body")[0].classList.add(styles.stopScrolling)
                    return { select: this.props.childState.select }
                }
            })
        }
    }
    componentWillUnmount() {
        if (this.timeInst)
            clearTimeout(this.timeInst)
    }
    render() {

        // select comp
        const id = this.props.id
        const extList = (this.state.extendCompVisible) ? this.ExtCompList() : ""
        const style = this.updateStyle()
        return (
            <div id={id} key={id} className={styles.container} style={style}
                ref={this.mountRefHandler}
                onClick={this.selectHandler}
                onMouseEnter={this.enableExtCompHandler}
                onMouseLeave={this.disableExtCompHandler}>
                {this.props.children}
                {extList}
            </div>
        )
    }
}

